module.exports = __webpack_public_path__ + "resources/img/img_icon_akamaiAAP.9ac3d2f2326eb9aee50aae9043dde496.png";